import {produce} from 'immer'

import type {KeyValue} from '@jetbrains/teamcity-ui/dist/utils'
import {objectEntries} from '@jetbrains/teamcity-ui/dist/utils'

export type WritableMap<K extends PropertyKey, V> = Map<K, V>
export const objectFromEntries = <T>(entries: [keyof T, T[keyof T]][]) =>
  Object.fromEntries(entries) as Partial<T>
export const keyValue = <K extends PropertyKey, V>(key: K, value: V): KeyValue<K, V> =>
  objectFromEntries([[key, value]])

export const mapValues = <T extends Record<string, unknown>, R extends Record<keyof T, unknown>>(
  object: T,
  callback: <K extends keyof T>(value: T[K], key: K) => R[K],
): R =>
  objectFromEntries<R>(
    objectEntries(object).map(([key, value]) => [key, callback(value, key)]),
  ) as R
// inside createReducer/createSlice, use Object.assign instead
export const mergeIfDifferent = <T extends {}>(
  dest: T,
  src: Readonly<Partial<T>> | null | undefined,
): T =>
  produce(dest, draft => {
    Object.assign(draft, src)
  })
